import React, { ReactNode } from "react"
import SbEditable from "storyblok-react"
import { unified } from "unified"
import remarkParse from "remark-parse"
import remarkRehype from "remark-rehype"
import rehypeReact from "rehype-react"
import remarkReactComponents from "../../helpers/remarkReactComponents"
import { StyledFormCopy } from "./partials"

export const StoryblokFormCopy = ({ isDark, loading, title, copy }) => {
    return (
        <StyledFormCopy dark_form={isDark}>
            {title && <h3>{title}</h3>}
            {copy && <div>
                {
                    unified()
                        .use(remarkParse)
                        .use(remarkRehype)
                        .use(rehypeReact as any, {
                            createElement: React.createElement,
                            components: remarkReactComponents,
                            Fragment: React.Fragment
                        })
                        .processSync(copy.replace(/\n/g, "  \n"))
                        .result as ReactNode
                }
            </div>}
        </StyledFormCopy>
    )
}
